import {
    deleteAslDeviceConfigDetails,
    deleteAslDeviceDetails,
    fetchAslDeviceDetails,
    setAslDeviceDetails,
    updateAslConfigDetails,
    updateAslDeviceDetails
} from "../network/AslDeviceOverviewNetworkAPI";

export const AslDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_VIEW":
            fetchAslDeviceDetails(action.data.dispatcher)
            return state
        case "ADD_CONFIG_DATA":
            updateAslConfigDetails(action.data.dispatcher, action.data.divertConfig, action.data.mac)
            return state
        case "ADD_DEVICE_DATA":
            setAslDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAslDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAslDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "DELETE_DEVICE_CONFIG_DATA":
            deleteAslDeviceConfigDetails(action.data.dispatcher, action.data.mac, action.data.divertCode)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/reducer/AslDeviceOverviewReducer.js